import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import RadioButton from '@deprecated-ui/company/Radio';
import { FR_CHART_TYPES } from 'features/company/constants';
import debounce from 'lodash.debounce';
import { useCallback } from 'react';

interface ChartTypeButtonsProps {
  showChartType: boolean;
  chartType: string;
  onSelectChartType: (v: string) => void;
  className?: string;
}

function ChartTypeButtons({
  showChartType,
  chartType,
  onSelectChartType,
  className,
}: ChartTypeButtonsProps) {
  const debouncedOnChange = useCallback(
    debounce((e: React.ChangeEvent<HTMLInputElement>) => {
      onSelectChartType(e.target.value as string);
    }, 0),
    [onSelectChartType],
  );

  return showChartType ? (
    <Flex className={className}>
      <RadioButton.Group
        value={chartType}
        onChange={debouncedOnChange}
        // @ts-expect-error
        type="solid-primary"
      >
        {FR_CHART_TYPES.map((opt) => (
          <RadioButton.Button key={opt.value} value={opt.value}>
            <Text
              className="text"
              height="1.15"
              padding="2px 8px"
              align="center"
            >
              {opt.label}
            </Text>
          </RadioButton.Button>
        ))}
      </RadioButton.Group>
    </Flex>
  ) : null;
}

export default ChartTypeButtons;
